var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3662_148298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 4.02947 13.9705 0 9 0C4.02947 0 0 4.02947 0 9C0 13.2209 2.90573 16.7624 6.8258 17.7349V11.7502H4.96997V9H6.8258V7.81495C6.8258 4.75158 8.21208 3.33183 11.2195 3.33183C11.7897 3.33183 12.7735 3.44348 13.176 3.55542V6.04856C12.9637 6.0262 12.5947 6.01495 12.1362 6.01495C10.6605 6.01495 10.0903 6.57394 10.0903 8.0273V9H13.03L12.525 11.7502H10.0903V17.934C14.5467 17.3959 18 13.6014 18 9Z",
    fill: "#0766FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5253 11.7505L13.0303 9.00034H10.0907V8.02764C10.0907 6.57428 10.6607 6.0153 12.1365 6.0153C12.5949 6.0153 12.9639 6.02641 13.1762 6.04877V3.55577C12.7738 3.44383 11.79 3.33203 11.2197 3.33203C8.21232 3.33203 6.82604 4.75192 6.82604 7.8153V9.00034H4.97021V11.7505H6.82604V17.7353C7.52242 17.9081 8.25043 18.0003 9.00025 18.0003C9.36939 18.0003 9.73304 17.9776 10.0907 17.9344V11.7505",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3662_148298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.025b6ede29209392cd235958ac565164.svg";
export { ForwardRef as ReactComponent };